// Mode persistance → label humain pour Verdict / Deliberation headers
const MODE_LABELS: Record<string, string> = {
  auto: "Détection auto",
  validation: "Validation",
  marche: "Marché",
  pricing: "Pricing",
  produit: "Produit",
  levee: "Levée",
  plan: "Plan stratégique",
  tendances: "Tendances",
};

export function modeToLabel(mode: string | null | undefined): string {
  if (!mode) return "Détection auto";
  const key = mode
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (MODE_LABELS[key]) return MODE_LABELS[key];
  // Déjà sous forme humaine (ex. "Levée") → laisser passer
  if (Object.values(MODE_LABELS).some((v) => v.toLowerCase() === mode.toLowerCase())) {
    return mode;
  }
  return mode;
}

export function formatDurationFr(minutesRaw: number): string {
  if (!Number.isFinite(minutesRaw) || minutesRaw <= 0) return "moins d'une minute";
  const totalSeconds = Math.round(minutesRaw * 60);
  const min = Math.floor(totalSeconds / 60);
  const sec = totalSeconds % 60;
  if (min === 0) return `${sec} sec`;
  if (sec === 0) return `${min} min`;
  return `${min} min ${sec} sec`;
}

export function computeDurationMinutes(
  createdAt: string | null | undefined,
  finishedAt: string | null | undefined,
): number {
  if (!createdAt || !finishedAt) return 0;
  const a = new Date(createdAt).getTime();
  const b = new Date(finishedAt).getTime();
  if (!Number.isFinite(a) || !Number.isFinite(b) || b <= a) return 0;
  return (b - a) / 60000;
}

// Convert a 0-10 OR 0-1 conviction score into a 0-100 percent for display.
export function convictionToPercent(score: number): number {
  if (!Number.isFinite(score) || score <= 0) return 0;
  const pct = score <= 1 ? score * 100 : score * 10;
  return Math.max(0, Math.min(100, Math.round(pct)));
}
